import { PageHeaderComponent } from '@aston/foundation';
import { TranslateModule } from '@ngx-translate/core';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { Store } from '@ngrx/store';

import { LayoutBaseComponent } from '../../../shared-module/layouts/layout-base/layout-base.component';
import { TopBarComponent } from '../../../shared-module/components/top-bar/top-bar.component';
import { MenuLinksComponent } from '../../components/menu-links/menu-links.component';
import { MenuComponent } from '../../../shared-module/components/menu/menu.component';
import { ActiveRouteService } from '../../../shared-module/services';
import * as RoutesDefinitions from '../../../routes-definitions';


@Component({
	selector: 'subsidiaries-menu-layout',
	templateUrl: './subsidiaries-menu-layout.component.html',
	imports: [AsyncPipe, RouterModule, LayoutBaseComponent, MenuLinksComponent, PageHeaderComponent, TranslateModule, MenuComponent, TopBarComponent]
})
export class SubsidiariesMenuLayoutComponent extends LayoutBaseComponent {
	private activeRouteService = inject(ActiveRouteService);
	protected store = inject(Store);

	subsidiariesRoutePath = RoutesDefinitions.getSubsidiariesFullPath();
	tenantTitle$ = this.activeRouteService.tenantTitle$;
}
